<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col class="text-center text-sm-left flex-header mb-sm-0">
                <h3 class="page-title">Edycja spółki</h3>
                <d-button theme="secondary" @click.prevent="$router.push({name: 'companies-list'})"><i class="material-icons">keyboard_backspace</i> Wróć do listy</d-button>
                <d-button theme="success" @click.prevent="submitForm"><i class="material-icons">save</i> Zapisz zmiany</d-button>
            </d-col>
        </d-row>

        <div v-if="!loaded">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <d-card class="card-small" v-if="loaded">

                <!-- Form Example -->
                <d-card-header class="border-bottom">
                    <h6 class="m-0">Dane spółki</h6>
                </d-card-header>

                <d-list-group flush @keyup.enter="submitForm">
                    <d-list-group-item class="p-3">
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.name" name="name" label="Nazwa spółki" placeholder="Nazwa spółki"></ss-input>
                            </d-col>
                        </d-row>
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.account_bank_name" name="account_bank_name" label="Nazwa banku" placeholder="Nazwa banku"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.account_number" name="account_number" label="Numer konta" placeholder="Numer konta"></ss-input>
                            </d-col>
                        </d-row>
                        <d-row>
                            <d-col md="6" class="form-group">
                                <label for="nip">Nip</label>
                                <d-input id="nip"
                                         type="text"
                                         name="nip"
                                         v-model="data.nip"
                                         v-mask="'##########'"
                                         @input="lar_errors.clear('nip')"
                                         :class="{'is-invalid' : lar_errors.has('nip')}"
                                         placeholder="Nip" />
                                <div class="invalid-feedback" v-text="lar_errors.get('nip')"></div>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.regon" name="regon" label="Regon" placeholder="Regon"></ss-input>
                            </d-col>
                        </d-row>
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.krs_number" name="krs_number" label="KRS" placeholder="KRS"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.faculty_number" name="faculty_number" label="Numery wydziału KRS" placeholder="Numery wydziału KRS"></ss-input>
                            </d-col>
                        </d-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <label for="phone">Telefon</label>
                                <d-input
                                        id="phone"
                                        type="text"
                                        name="phone"
                                        v-model="data.phone"
                                        @input="lar_errors.clear('phone')"
                                        :class="{'is-invalid' : lar_errors.has('phone')}"
                                        placeholder="Nr telefonu" />
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.email" name="email" label="Adres e-mail" placeholder="Adres e-mail"></ss-input>
                            </d-col>
                        </d-form-row>
                        <ss-textarea v-model="data.contract_extra_text"
                                     name="contract_extra_text"
                                     label="Oświadczenie pożyczkodawcy w umowie pożyczki pkt.2 §6."
                                     placeholder="Opis..."></ss-textarea>
                    </d-list-group-item>

                    <d-card-header>
                        <h6 class="m-0">Dane do faktury</h6>
                    </d-card-header>

                    <d-list-group-item class="p-3">
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.invoice_name" name="invoice_name" label="Nazwa" placeholder="Nazwa"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.invoice_address" name="invoice_address" label="Ulica" placeholder="Ulica"></ss-input>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.invoice_house_number" name="invoice_house_number" label="Numer mieszkania" placeholder="Nazwa kancelarii"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.invoice_flat_number" name="invoice_flat_number" label="Numer lokalu" placeholder="Numer lokalu"></ss-input>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.invoice_city" name="invoice_city" label="Miasto" placeholder="Miasto"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.invoice_postcode" name="invoice_postcode" label="Kod pocztowy" placeholder="Kod pocztowy"></ss-input>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <label for="invoice_tax_number">Nip</label>
                                <d-input id="invoice_tax_number"
                                         type="text"
                                         name="invoice_tax_number"
                                         v-model="data.invoice_tax_number"
                                         v-mask="'##########'"
                                         @input="lar_errors.clear('invoice_tax_number')"
                                         :class="{'is-invalid' : lar_errors.has('invoice_tax_number')}"
                                         placeholder="Nip" />
                                <div class="invalid-feedback" v-text="lar_errors.get('invoice_tax_number')"></div>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="data.invoice_prefix" name="invoice_prefix" label="Prefix faktury" placeholder="Prefix faktury"></ss-input>
                            </d-col>
                        </d-form-row>
                    </d-list-group-item>

                    <d-card-header>
                        <h6 class="m-0">Dane do fakturowni</h6>
                    </d-card-header>

                    <d-list-group-item class="p-3">
                        <d-row>
                            <d-col md="4" class="form-group">
                                <ss-input v-model="data.fakturownia_department_id" name="fakturownia_department_id" label="Id sprzedawcy" placeholder="Id sprzedawcy"></ss-input>
                            </d-col>
                            <d-col md="4" class="form-group">
                                <ss-input v-model="data.fakturownia_token" name="fakturownia_token" label="Token" placeholder="Token"></ss-input>
                            </d-col>
                            <d-col md="4" class="form-group">
                                <ss-input v-model="data.fakturownia_api_url" name="fakturownia_api_url" label="Adres url API" placeholder="Adres url API"></ss-input>
                            </d-col>
                        </d-row>
                    </d-list-group-item>
                </d-list-group>

            </d-card>
        </transition>
    </d-container>
</template>

<script>
import LarErrors from '@/helpers/Errors';
import FormUtils from '@/utils/FormUtils.js';

export default {
    name: 'CompanyEdit',
    components: {
        LarErrors
    },
    data () {
        return{
            loaded: false,
            lar_errors: LarErrors,
            data: {
                id:                 '',
                name:               '',
                account_bank_name:  '',
                account_number:     '',
                invoice_name:       '',
                invoice_address:    '',
                invoice_city:       '',
                invoice_postcode:   '',
                invoice_tax_number: '',
                invoice_prefix:     '',
                krs_number:         '',
                nip:                '',
                regon:              '',
                faculty_number:     '',
                fakturownia_department_id: '',
                fakturownia_token: '',
                fakturownia_api_url: '',
                email:              '',
                phone:              '',
                contract_extra_text:  '',
            }
        }
    },
    methods: {
        fetchData () {
            FormUtils.loadItemData(this, {
                method: 'post',
                endpointBase: '/api/companies/get-company',
                id: null,
                params: {
                    id: this.$route.params.id
                },
                instanceFields: [
                    'id',
                    'name',
                    'account_bank_name',
                    'account_number',
                    'invoice_name',
                    'invoice_address',
                    'invoice_city',
                    'invoice_postcode',
                    'invoice_tax_number',
                    'invoice_prefix',
                    'krs_number',
                    'nip',
                    'regon',
                    'faculty_number',
                    'fakturownia_department_id',
                    'fakturownia_token',
                    'fakturownia_api_url',
                    'email',
                    'phone',
                    'contract_extra_text'
                ],
                loadedKey: 'loaded'
            });
        },
        submitForm () {
            axios.post('api/companies/save-company', this.data).then(response => {
                Vue.swal({
                    type: 'success',
                    title: 'Zmiany zostały zapisane.',
                    showConfirmButton: true,
                }).then(() => {
                    this.fetchData();
                });
            }).catch((error) =>{
                Vue.swal({
                    type: 'error',
                    title: error.response.data.message,
                    html: Vue.transformErrorsToHtml(error.response.data.errors),
                    showConfirmButton: true,
                });
                LarErrors.record(error.response.data.errors)
            })
        }
    },
    mounted(){
        this.fetchData();
    }
}
</script>
